<template>
  <slice
    :id="block._key"
    class="slice--impacts container"
    @in="init()"
    @out="$emit('out')"
  >
    <portable-text
      v-if="block.text && block.text.length > 0"
      :blocks="block.text"
      class="text-center mb-2 mb-md-6"
    />

    <div class="row-md justify-center">
      <div class="col-md-8">
        <div class="row-md">
          <div
            v-for="item in block.list"
            :key="item._key"
            class="col-md-4 impacts__item"
          >
            <component :is="icon(item.type)" />

            <p class="h4 mb-0-2">
              {{ item.value }}&nbsp;{{ $t(`impact.unit.${item.type}`) }}
            </p>

            <p class="rich-text w-600 mb-0-2">
              <span>{{ $t(`impact.conso.${item.type}`) }}</span>
            </p>

            <portable-text
              v-if="item.equivalent && item.equivalent.length > 0"
              :blocks="item.equivalent"
              class="text-small tooltip impacts__equivalence mb-0"
              :data-tippy-content="$t(`impact.detail.${item.type}`)"
            />
          </div>
        </div>
      </div>
    </div>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'
import SliderDots from '@/components/slider/SliderDots'
import CarbonIcon from '@/components/icons/Carbon'
import EnergyIcon from '@/components/icons/Energy'
import WaterIcon from '@/components/icons/Water'

import { IMPACTS } from '@/const'

export default {
  name: 'BlockImpact',
  components: {
    Slice,
    PortableText,
    SliderDots,
    CarbonIcon,
    EnergyIcon,
    WaterIcon,
  },
  props: { block: { type: Object, required: true } },
  data() {
    return {
      conf: {
        slidesPerView: 1,
        a11y: {
          enabled: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 3,
          },
        },
      },
    }
  },
  methods: {
    async init() {
      this.$emit('in')

      const tippy = await import('tippy.js' /* webpackChunkName: 'tippy' */)
      await import(
        '@/scss/09-libs/_06-tippy.scss' /* webpackChunkName: 'tippy_css' */
      )
      await import(
        'tippy.js/animations/scale.css' /* webpackChunkName: 'tippy_animation_scale_css' */
      )

      tippy.default('.impacts__equivalence', {
        theme: 'dark',
        placement: 'top',
        animation: 'scale',
        arrow: true,
      })
    },
    icon(type) {
      if (type === IMPACTS.CARBON) {
        return CarbonIcon
      }

      if (type === IMPACTS.ENERGY) {
        return EnergyIcon
      }

      return WaterIcon
    },
  },
}
</script>

<style lang="scss">
.impacts {
  p {
    padding: 0;
  }

  &__slider {
    margin: rem($spacing * 3) auto 0;

    @include mq($from: tablet) {
      margin: rem($spacing * 4) auto 0;
    }
  }

  &__item {
    text-align: center;

    @include mq($until: tablet) {
      margin-bottom: rem($spacing * 2);
    }

    .icon {
      width: auto;
      height: rem(70px);
      pointer-events: none;
      margin: 0 auto rem($spacing * 1.5);

      @include mq($from: tablet) {
        margin: 0 auto rem($spacing * 2);
      }
    }
  }

  &__equivalence {
    p {
      display: inline-block;
    }

    .tooltip {
      white-space: normal;
    }
  }
}
</style>
